"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLEX_DATES = void 0;
var FLEX_DATES = [{
  title: 'Точные даты',
  shiftValue: 0
}, {
  title: '± 1 день',
  shiftValue: 1
}, {
  title: '± 2 дня',
  shiftValue: 2
}];
exports.FLEX_DATES = FLEX_DATES;